
import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

const EmailPreview = ({ template, previewData }) => {
  // Fonction pour remplacer les variables dans le contenu
  const replaceVariables = (content) => {
    if (!content) return '';
    
    const sampleData = {
      nom: previewData?.nom || "Dupont",
      prenom: previewData?.prenom || "Jean",
      formation: previewData?.formation || "Formation React Avancée",
      date_debut: previewData?.date_debut || "01/06/2025",
      date_fin: previewData?.date_fin || "05/06/2025",
      lieu: previewData?.lieu || "Paris"
    };
    
    let replacedContent = content;
    Object.keys(sampleData).forEach(key => {
      const regex = new RegExp(`{${key}}`, 'g');
      replacedContent = replacedContent.replace(regex, sampleData[key]);
    });
    
    return replacedContent;
  };
  
  // Préparation du contenu avec les variables remplacées
  const processedSubject = replaceVariables(template.subject);
  const processedContent = replaceVariables(template.content);
  
  return (
    <div className="space-y-6">
      <Card className="rounded-2xl border-slate-200/80 shadow-sm overflow-hidden">
        <CardHeader className="bg-slate-50/70 border-b border-slate-200/80">
          <CardTitle className="text-base font-black text-slate-900">Aperçu du mail</CardTitle>
        </CardHeader>
        <CardContent className="p-6">
          <div className="space-y-4">
            <div className="flex flex-col gap-0.5">
              <p className="text-xs font-bold uppercase tracking-wider text-slate-400">De</p>
              <p className="font-semibold text-slate-700">Votre Organisation &lt;contact@votreorganisation.com&gt;</p>
            </div>

            <div className="flex flex-col gap-0.5">
              <p className="text-xs font-bold uppercase tracking-wider text-slate-400">À</p>
              <p className="font-semibold text-slate-700">{previewData?.prenom || "Jean"} {previewData?.nom || "Dupont"} &lt;jean.dupont@example.com&gt;</p>
            </div>

            <div className="flex flex-col gap-0.5">
              <p className="text-xs font-bold uppercase tracking-wider text-slate-400">Sujet</p>
              <p className="font-black text-slate-900">{processedSubject}</p>
            </div>

            <div className="pt-5 mt-1 border-t border-slate-200/80">
              <div
                className="prose max-w-none"
                dangerouslySetInnerHTML={{ __html: processedContent }}
              />
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default EmailPreview;
